import styled from 'styled-components'
import { InteractionsAnim } from 'animations/Interactions'

const { textClick } = InteractionsAnim()

interface props {
  anim: boolean
  clickable?: boolean
}
export const OtherPages = styled.div<props>`
  line-height: 3.2;
  ${({ anim }) => anim && textClick};
  pointer-events: ${({ clickable }) => (clickable ? 'auto;' : 'none;')};
  h3 {
    font-size: 20px;
    text-transform: capitalize;
    cursor: pointer;
  }
`
